import { GET_USERS } from "../types/userType";

const initialState = {
    users: [],
    totalElements: 0,
    size: null,
    number: null
};

const userReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_USERS:
            return {
                ...state,
                users: payload.content,
                totalElements: payload.totalElements
            };
        default:
            return state;
    }
};

export default userReducer;
